var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUploadDnaIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 69,
    height: 70,
    viewBox: "0 0 69 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1-dna, .cls-3-dna {\n        fill: none;\n        stroke: #0e525f;\n        stroke-linecap: round;\n      }\n\n      .cls-2-dna {\n        fill: #dcedeb;\n      }\n\n      .cls-3-dna {\n        stroke-linejoin: round;\n        stroke-width: 2px;\n      }\n\n      .cls-4-dna {\n        clip-path: url(#clip-path);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5268",
    "data-name": "Rectangle 5268",
    className: "cls-1-dna",
    width: 46.036,
    height: 46.036
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6242",
    "data-name": "Group 6242",
    transform: "translate(-20 -521)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6243",
    "data-name": "Group 6243"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2021",
    "data-name": "Ellipse 2021",
    className: "cls-2-dna",
    cx: 34.5,
    cy: 35,
    rx: 34.5,
    ry: 35,
    transform: "translate(20 521)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6241",
    "data-name": "Group 6241",
    transform: "translate(29.526 531.173)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1468",
    "data-name": "Line 1468",
    className: "cls-3-dna",
    x2: 8.231,
    y2: 8.231,
    transform: "translate(16.463 16.462)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6240",
    "data-name": "Group 6240",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6239",
    "data-name": "Group 6239",
    className: "cls-4-dna"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22683",
    "data-name": "Path 22683",
    className: "cls-3-dna",
    d: "M17.982,33.47c1.06,3.082.972,6-1.678,8.652l-1.162,1.162",
    transform: "translate(-0.217 -0.481)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1469",
    "data-name": "Line 1469",
    className: "cls-3-dna",
    x2: 5.699,
    y2: 6.332,
    transform: "translate(15.829 21.528)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1470",
    "data-name": "Line 1470",
    className: "cls-3-dna",
    x2: 9.758,
    y2: 9.758,
    transform: "translate(4.47 29.56)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1471",
    "data-name": "Line 1471",
    className: "cls-3-dna",
    x2: 6.969,
    y2: 6.969,
    transform: "translate(8.652 28.167)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22684",
    "data-name": "Path 22684",
    className: "cls-3-dna",
    d: "M33.474,17.983c3.081,1.058,6,.969,8.648-1.679l1.162-1.162",
    transform: "translate(-0.481 -0.218)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22685",
    "data-name": "Path 22685",
    className: "cls-3-dna",
    d: "M23.756,13.43c-3.081-1.058-6-.969-8.648,1.679s-2.737,5.57-1.678,8.652",
    transform: "translate(-0.184 -0.184)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22686",
    "data-name": "Path 22686",
    className: "cls-3-dna",
    d: "M21.7,31.327a22.533,22.533,0,0,1-6.177-2.674c-4.815-2.771-9.39-4.548-13.358-.581L1,29.233",
    transform: "translate(-0.014 -0.37)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22687",
    "data-name": "Path 22687",
    className: "cls-3-dna",
    d: "M29.233,1,28.072,2.161c-3.968,3.968-2.191,8.543.581,13.358a25.993,25.993,0,0,1,2.415,5.189",
    transform: "translate(-0.37 -0.014)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1472",
    "data-name": "Line 1472",
    className: "cls-3-dna",
    x2: 6.332,
    y2: 5.699,
    transform: "translate(21.528 15.829)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1473",
    "data-name": "Line 1473",
    className: "cls-3-dna",
    x2: 9.757,
    y2: 9.758,
    transform: "translate(29.561 4.47)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1474",
    "data-name": "Line 1474",
    className: "cls-3-dna",
    x2: 6.969,
    y2: 6.969,
    transform: "translate(28.167 8.652)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2020",
    "data-name": "Ellipse 2020",
    className: "cls-3-dna",
    cx: 8.864,
    cy: 8.864,
    r: 8.864,
    transform: "translate(24.694 23.427)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1475",
    "data-name": "Line 1475",
    className: "cls-3-dna",
    x2: 6.332,
    y2: 6.332,
    transform: "translate(39.257 39.257)"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadDnaIcon);
export default __webpack_public_path__ + "static/media/upload-dna-icon.d0f4447d.svg";
export { ForwardRef as ReactComponent };